export default function replaceHyphenation(
  text: string,
  searchSymbol?: string
): string {
  const search = searchSymbol || "~"
  return text.replace(search, "\xAD") // \xAD is the soft hyphen character.
}
